import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {PageService} from "../service/page.service";
import {CmsPage} from "../model/page";

@Injectable()
export class PageResolve implements Resolve<CmsPage> {
    constructor(private pageService: PageService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<CmsPage> {
        return this.pageService.getById(route.params.id);
    }
}
